import React, { ReactNode } from 'react';
import { FaTimes } from 'react-icons/fa';
import '../TaskForm/usuario-form.css';

export interface AgentGroupModalShellProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  leading?: ReactNode;
}

const AgentGroupModalShell = ({ title, onClose, children, leading }: AgentGroupModalShellProps) => (
  <div className="agent-group-modal">
    <div className="agent-group-modal__header">
      <div className="agent-group-modal__title-row">
        {leading ? <span className="agent-group-modal__leading">{leading}</span> : null}
        <h1 className="agent-group-modal__title">{title}</h1>
      </div>
      <button
        type="button"
        className="agent-group-modal__close"
        onClick={onClose}
        aria-label="Fechar"
      >
        <FaTimes size={18} />
      </button>
    </div>
    <div className="agent-group-modal__body">{children}</div>
  </div>
);

export default AgentGroupModalShell;
